export default __webpack_public_path__ + "static/media/media6.7ff1a3b9.jpeg";